var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBullhorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m17.5 1.9-1 .72s-1.24.92-3.02 1.83c-1.79.92-4.11 1.8-6.16 1.8H1.25v5.7l.02.1 1.25 4.38.14.45h3.79l-.22-.8-1.02-3.58h2.11c2.02 0 4.34.9 6.14 1.82 1.79.91 3.04 1.81 3.04 1.81l1 .73v-5.73a1.9 1.9 0 0 0 1.25-1.76c0-.8-.53-1.5-1.25-1.75zm-1.25 2.32v10.3c-.52-.36-.93-.67-2.23-1.34-1.83-.93-4.2-1.88-6.52-1.93V7.5c2.34-.05 4.71-1.02 6.54-1.95 1.3-.67 1.7-.98 2.21-1.33M2.5 7.5h3.75v3.75H2.5zm.21 5h1.2l.88 3.13h-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBullhorn);
export default ForwardRef;